import _classCallCheck from "/Users/dashnyamlhagwasuren/Desktop/github/contentlab_frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dashnyamlhagwasuren/Desktop/github/contentlab_frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/dashnyamlhagwasuren/Desktop/github/contentlab_frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/dashnyamlhagwasuren/Desktop/github/contentlab_frontend/node_modules/@babel/runtime/helpers/esm/createSuper";
import { PolygonDrawerBase } from "./PolygonDrawerBase";
export var PolygonDrawer = /*#__PURE__*/function (_PolygonDrawerBase) {
  _inherits(PolygonDrawer, _PolygonDrawerBase);
  var _super = _createSuper(PolygonDrawer);
  function PolygonDrawer() {
    _classCallCheck(this, PolygonDrawer);
    return _super.apply(this, arguments);
  }
  _createClass(PolygonDrawer, [{
    key: "getSidesData",
    value: function getSidesData(particle, radius) {
      var _a, _b;
      var polygon = particle.shapeData;
      var sides = (_b = (_a = polygon === null || polygon === void 0 ? void 0 : polygon.sides) !== null && _a !== void 0 ? _a : polygon === null || polygon === void 0 ? void 0 : polygon.nb_sides) !== null && _b !== void 0 ? _b : 5;
      return {
        count: {
          denominator: 1,
          numerator: sides
        },
        length: radius * 2.66 / (sides / 3)
      };
    }
  }, {
    key: "getCenter",
    value: function getCenter(particle, radius) {
      var sides = this.getSidesCount(particle);
      return {
        x: -radius / (sides / 3.5),
        y: -radius / (2.66 / 3.5)
      };
    }
  }]);
  return PolygonDrawer;
}(PolygonDrawerBase);